/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactUploadBatchResponse } from '../../models/api-response-contact-upload-batch-response';

export interface GetUploadBatchStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  batchReference: string;
}

export function getUploadBatchStatus(http: HttpClient, rootUrl: string, params: GetUploadBatchStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactUploadBatchResponse>> {
  const rb = new RequestBuilder(rootUrl, getUploadBatchStatus.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('batchReference', params.batchReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactUploadBatchResponse>;
    })
  );
}

getUploadBatchStatus.PATH = '/v1/api/ui/contacts/upload/status/{batchReference}';
